<template>
    <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
        <i class="fal fa-spinner fa-spin" /> Result Export Loading...
    </div>
    <div v-else class="animated fadeIn">
        <basic-heading :title="'Export Detail'"></basic-heading>
        <div class="mt-2 mb-3">
            <ResultExportDownloadButton :result_export="resultExport" size="lg" class="mr-1"></ResultExportDownloadButton>
            <ResultExportImportButton :result_export="resultExport" size="lg"></ResultExportImportButton>
        </div>
        <result-export-card :resultExport="resultExport"></result-export-card>
        <ResultImportCardstack :export_id="result_export_id" />
    </div>
</template>
<script>
import BasicHeading from '@/components/shared/BasicHeading.vue';
import ContextPills from "@/components/shared/ContextPills";
import ResultExportCard from '@/components/lab/resultexport/ResultExportCard.vue';
import ResultExportImportButton from '@/components/lab/resultexport/ResultExportImportButton.vue';
import { getModel } from '@/shared/fetch-utils';
import ResultExportDownloadButton from '@/components/lab/resultexport/ResultExportDownloadButton.vue';
import ResultImportCardstack from '@/components/lab/resultimport/ResultImportCardStack.vue';

export default {
    name: "ResultExportDetail",
    components: {
    BasicHeading,
    ContextPills,
    ResultExportCard,
    ResultExportImportButton,
    ResultExportDownloadButton,
    ResultImportCardstack
},
    data() {
        return {
            loading: false,
            result_export_id: this.$route.params.result_export_id || null,
            resultExport: null,
        };
    },
    async created() {
        this.loading = true

        this.resultExport = await getModel({
            model_type: "resultExport",
            id: this.result_export_id,
            message: this.$bvToast,
        });


        if (this.resultExport) {
            this.loading = false;
        } else {
            this.$router.back();
        }
    }
}
</script>